import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {MatTabGroup} from '@angular/material';
import {AsEnterpriseService} from '../../../../../core/services/as-enterprise.service';
import {EnterpriseService} from '../../../../../core/services/enterprise.service';
import {CommonService} from '../../../../../core/services/common.service';
import {Message} from '../../../../../core/class/message';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {DigitalCertificateService} from '../../../../../core/services/digital-certificate.service';
import {EnterpriseConfigService} from '../../../../../core/services/enterprise-config.service';
import {WarningComponent} from '../../../../../shared/components/warning/warning.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-enterprise-config',
  templateUrl: './enterprise-config.component.html',
  styleUrls: ['./enterprise-config.component.scss']
})
export class EnterpriseConfigComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  isInforTab = 0;
  form: FormGroup;
  dirty = false;
  enableOcspInit = false;
  maxSize = -1;
  titleMaxSize = "";
  subTitleMaxSize = "";
  @ViewChild('myTabGroup', { static: false }) myTabGroup: MatTabGroup;

  enterpriseConfigHsmAndBranch = {
    enableManageBranch: false,
    enableHsm: false,
    ipAlloweds: [],
    isIpAllowed: false,
    isTwoFactorAuthen: false,
    isTwoFactorAuthenExternal: false,
    isTwoFactorAuthenInternal: false,
    isEnterpriseActionLog: false,
    isShortName : false,
    shortName : '',
    shortNameEnterprise : {
      isShortName : false,
      shortName: ''
    }
  };

  private enterpriseId;

  enterprise;

  constructor(private enterpriseService: EnterpriseService ,
              public commonService: CommonService,
              private dialog: MatDialog,
              private enterpriseConfigService: EnterpriseConfigService,
              public message: Message, fb: FormBuilder ) {
    super(commonService, message);
    this.form = fb.group({
      enableOcsp: [false],
    });
  }

  ngOnInit() {
   this.loadData();
  }

  loadData() {
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.enterpriseService.getEnterpriseByID(this.enterpriseId).subscribe(rs => {
      if (rs != null && rs.data != null) {
        const responsedData = rs.data;
        console.log(responsedData);
        this.enterprise = responsedData;

      }
    });
    this.enterpriseService.getPermissionManageBranch(this.enterpriseId).subscribe(rs => {
      if (rs != null && rs.data != null) {
        this.form.setValue({
          enableOcsp: rs.data.enableOcsp ? rs.data.enableOcsp :  false,
          // isEnterpriseActionLog: rs.data.isEnterpriseActionLog ? rs.data.isEnterpriseActionLog :  false,
        });
        this.enableOcspInit = this.form.value.enableOcsp;
        this.maxSize = rs.data.maxSize;
        this.titleMaxSize = rs.data.maxSize == -1 ? this.message.getMessage('title.allow_large_file') : this.commonService.format(this.message.getMessage('title.large_file_X'), +rs.data.maxSize / (1024 * 1024) + "MB)");
        this.subTitleMaxSize = rs.data.maxSize !== -1 ? this.message.getMessage('title.default_upload_file') : this.message.getMessage('messages.allow_large_file');
        let ipAlloweds = [];
        if (rs.data.ipAlloweds) {
          ipAlloweds = rs.data.ipAlloweds.map((e, index) => {
            e.order = index + 1;
            e.id = this.commonService.generateUUID();
            return e;
          })
        }
        // if(!rs.data.isShortName){
        //   rs.data.shortNameEnterprise.isShortName = false;
        //   rs.data.shortNameEnterprise.shortName = '';
        // }
        this.enterpriseConfigHsmAndBranch = {
          enableHsm: rs.data.enableHsm,
          enableManageBranch: rs.data.enableManageBranch,
          ipAlloweds: ipAlloweds,
          isIpAllowed: rs.data.isIpAllowed,
          isTwoFactorAuthen: rs.data.isTwoFactorAuthen,
          isTwoFactorAuthenExternal: rs.data.isTwoFactorAuthenExternal,
          isTwoFactorAuthenInternal: rs.data.isTwoFactorAuthenInternal,
          isEnterpriseActionLog: rs.data.isEnterpriseActionLog,
          isShortName : rs.data.isShortName,
          shortName: rs.data.shortNameEnterprise.shortName,
          shortNameEnterprise : {
          isShortName : rs.data.shortNameEnterprise.isShortName,
          shortName: rs.data.shortNameEnterprise.shortName
          }
        };

        localStorage.setItem('shortNameSave', rs.data.shortNameEnterprise.shortName || '');
      }
    });
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
  }

  public onNoClick() {
    this.form.setValue({...this.form.value, enableOcsp: this.enableOcspInit})
    this.dirty = this.enableOcspInit !== this.form.value.enableOcsp;
  }

  public onSave() {
    console.log(this.form.value);

    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_save'))
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.enterpriseService.updateEnterpriseConfig({
          id: this.enterpriseId,
          ...this.form.value
        }).subscribe(res => {
          if (res && res.success) {
            console.log(res);
            this.enableOcspInit = this.form.value.enableOcsp;
            this.dirty = this.enableOcspInit !== this.form.value.enableOcsp;
            // xóa cache để sidebar/dashboard đọc config mới ở lần gọi sau
            this.enterpriseConfigService.invalidate();
          }
        });
      }
    });

  }

  onCheckboxChange(event: any) {
    this.dirty = this.enableOcspInit !== this.form.value.enableOcsp;
    console.log(this.dirty);
  }


}
